<script lang="ts">
  import { css, cx } from '@agapi/ui/panda/css';
  import { cardStyles } from '../card.styles';
  import type { CardHeaderProps } from '../card.types';

  const { css: cssProp, children, ...props }: CardHeaderProps = $props();

  const classes = cardStyles.raw()
</script>

<div class={css(classes.header, cssProp)} {...props}>
  {@render children?.()}
</div>
